/* eslint-disable react/no-danger */
import { Modal, TransitionablePortal } from 'semantic-ui-react';
import { func } from 'prop-types';

import css from './ModalSPA.less';

const SPA_URL = 'https://html.manadr.com/service-provider-agreement.html';

const ModalSPA = ({ onClose }) => {
  return (
    <div className={css.container}>
      <TransitionablePortal open transition={{ animation: 'fly up', duration: 500 }}>
        <Modal onClose={onClose} open closeIcon size="large" className={css.customModal}>
          <Modal.Header className={css.modalHeader}>Service Provider Agreement</Modal.Header>
          <Modal.Content className={css.modalContent}>
            <iframe
              src={SPA_URL}
              className={css.iframe}
              title="SPA"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    </div>
  );
};

export default ModalSPA;

ModalSPA.defaultProps = {};
ModalSPA.propTypes = {
  onClose: func.isRequired,
};
